const ROOT = "imageViewer";
const SETTINGS_MODAL = {
  IMAGE_PREVIEW: "imagePreview",
  CAPTION_INPUT: "imageSettingsCaptionInput",
  ALT_INPUT_TEXT: "imageSettingsAltInput"
};

export { ROOT, SETTINGS_MODAL };
//# sourceMappingURL=dataHooks.js.map
